interface ICSVExprot {
  headers: string[];
  data: string[];
  title?: string;
}

const generateCSV = ({ headers, data }: ICSVExprot) => {
  const headerRow = headers.join(",");
  const dataRows = data.map((row) =>
    headers.map((header) => row[header as any]).join(",")
  );
  return [headerRow, ...dataRows].join("\n");
};

export const exportCSV = (data: ICSVExprot) => {
  const csvContent = generateCSV(data);
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const title = data.title || "export";
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${title}.csv`;
  link.click();

  URL.revokeObjectURL(link.href);
};
